import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { LocalStorageService } from '../../../services/local-storage.service';
import { SANKEY_BEESWARM_MOCK_DATA } from './sankey-beeswarm-mock.data';
import { PageDataService } from 'src/app/services/page-data.service';

@Component({
  selector: 'app-sankey-bees-warm-card',
  templateUrl: './sankey-bees-warm-card.component.html',
  styleUrls: ['./sankey-bees-warm-card.component.scss']
})
export class SankeyBeesWarmCardComponent implements OnInit {
  static key = 100823;

  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  @Input("dynamic") dynamic!: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("SankeyBeesWarmChart", { static: true }) SankeyBeesWarmChart!: ElementRef;

  config: any;
  data: any;
  heading: any;
  isDataLoaded = false;
  triageTotaldata: any;
  error_name: any;
  reqSubcription: Subscription[] = [];

  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private localStorage: LocalStorageService,
    private pageDataService: PageDataService,
    private cdr: ChangeDetectorRef
  ) {}

  useMockData = false; // TODO: set to false when API is ready

  ngOnInit(): void {
    // Widget mode: component fetches its own data independently
    this.loadlineConfig();

    const cfg = this.item?.config;
    const dataMode = cfg?.['data_mode'] || 'page'; // 'page' | 'widget'

    if (dataMode === 'widget') {
      if (this.useMockData) {
        this.loadMockData();
      } else {
        this.reqSubcription.push(
          this.filterService.filterQuery.subscribe((query: any) => {
            this.loadApiData();
          })
        );
      }
    } else if (dataMode === 'page' && this.pageDataService.isActive) {
      let hasStartedLoading = false;

      // Page mode: data comes from centralized PageDataService
      this.reqSubcription.push(
        this.pageDataService.loading$.subscribe(loading => {
          if (loading) {
            hasStartedLoading = true;
          }
        })
      );

      const kpiRaw = cfg?.['kpi_1_value_api'] || cfg?.['kpi_value_api'] || cfg?.['list_of_api'];
      const apiKey = typeof kpiRaw === 'string' || typeof kpiRaw === 'number'
        ? kpiRaw
        : kpiRaw?.api_key;
      const stream$ = apiKey
        ? this.pageDataService.getDataStream(String(apiKey))
        : this.pageDataService.getCommonDataStream();

      this.reqSubcription.push(
        stream$.subscribe(res => {
          if (res && res.length > 0) {
            this.data = res;
            this.isDataLoaded = true;
            this.cdr.detectChanges();
          } else if (hasStartedLoading) {
            this.data = [];
            this.isDataLoaded = true;
            this.cdr.detectChanges();
          }
        })
      );
    }
    
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.SankeyBeesWarmChart.nativeElement);
  }

  loadlineConfig() {
    this.heading = this.item.config["report_heading"];
  }

  loadApiData(reportType?: string) {
    const api = this.item.config["list_of_api"] || 200348;
    const endpoint = this.item.config?.["list_of_api_endpoint"] || '';

    if (!this.filterService.isEmptyObject(this.filterService.baseQuery)) {
      const query = {
        ...this.filterService.baseQuery,
        api_key: api?.api_key ? api.api_key : api,
        report_typ: this.filterService.report_type
      };

      this.reqSubcription.push(
        this.httpClient.post(
          `${this.apiService.apiBaseUrl}/${endpoint || this.apiService.executionUrl}`,
          query
        ).subscribe({
          next: (res: any) => {
            this.data = res ?? [];
            this.triageTotaldata = { total: Array.isArray(res) ? res.length : 0 };
            // this.localStorage.set('totalTriaged', this.triageTotaldata);
            this.isDataLoaded = true;
            this.error_name = '';
          },
          error: (err) => {
            console.log("API Error", err);
            this.data = [];
            this.triageTotaldata = [];
            this.isDataLoaded = true;
            this.error_name = err?.error?.error?.message || err?.error?.message || err?.message || '';
          }
        })
      );
    }
  }

  loadMockData() {
    this.data = SANKEY_BEESWARM_MOCK_DATA;
    this.triageTotaldata = { total: SANKEY_BEESWARM_MOCK_DATA.length };
    this.isDataLoaded = true;
    this.error_name = '';
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach(res => res.unsubscribe());
    this.localStorage.remove('totalTriaged');
  }
}
